import PropTypes from "prop-types";

import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import {
  formatCount,
  getRegistrantLabel,
  getSessionNames,
  registrantShape,
} from "routes/swoogo/registrantSessions";
import useRemoveSessionRegistrants from "routes/swoogo/useRemoveSessionRegistrants";

const getConfirmationText = (registrants, sessionName) => {
  if (registrants.length === 1) {
    const name = getRegistrantLabel(registrants[0]);
    return `Remove ${name} from ${sessionName}? The change is made in Swoogo and takes some time to show. ${name} stays registered for the event.`;
  }
  return `Remove ${formatCount(registrants.length, "registrant")} from ${sessionName}? The change is made in Swoogo and takes some time to show. The registrants stay registered for the event.`;
};

/** Asks to remove the registrants from one known session in Swoogo. */
const ConfirmRemoveSessionRegistrantsDialog = ({
  registrants,
  sessionId,
  onOpenChange,
  onSuccess,
}) => {
  const removeMutation = useRemoveSessionRegistrants(registrants, () => {
    onOpenChange(false);
    onSuccess?.();
  });
  // Every registrant offered here is registered for the session, so their
  // own sessions carry its name.
  const sessionName = getSessionNames(registrants).get(sessionId);

  return (
    <ConfirmDeleteDialog
      open
      onOpenChange={onOpenChange}
      title="Remove from Session"
      description={getConfirmationText(registrants, sessionName)}
      confirmText="Remove"
      cancelVariant="ghost"
      onConfirm={() => removeMutation.mutate([sessionId])}
    />
  );
};

ConfirmRemoveSessionRegistrantsDialog.propTypes = {
  registrants: PropTypes.arrayOf(registrantShape).isRequired,
  sessionId: PropTypes.number.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};

export default ConfirmRemoveSessionRegistrantsDialog;
